import storeFactory from '@/core/factories/store'

import code from './code'

export default storeFactory(code)
